import { normalize } from 'normalizr';
import { query, mutation } from '@/dex-shared/helpers/graphql';
import { assignment } from '@/dex-shared/helpers/normalizr_schema';

/* 
  Action names
*/
let PULL_ASSIGNMENT_BY_USER_EMAIL = 'PULL_ASSIGNMENT_BY_USER_EMAIL';
let DELETE_ASSIGNMENT_BY_ID = 'DELETE_ASSIGNMENT_BY_ID';

export default {
  async [PULL_ASSIGNMENT_BY_USER_EMAIL](
    { commit, state }: any,
    { userEmail, examId }: any,
  ) {
    let getAssignmentResponse = await query(
      `
          query getUserAssignment($userEmail: String!, $examId: Int!) {
            userByEmail(email: $userEmail) {
              assignmentsByUserId(filter: { examId: {equalTo: $examId} }) {
                nodes {
                  id
                  createdAt
                  closedAt
                  repliesByAssignmentId {
                    totalCount
                  }
                  examByExamId {
                    id
                    name
                  }
                }
              }
            }
          }
        `,
      {
        userEmail,
        examId,
      },
    );
    let assignmentResponseData =
      getAssignmentResponse.data.userByEmail.assignmentsByUserId.nodes[0];
    if (!assignmentResponseData) {
      throw new Error('AssignmentNotFound');
    }
    const normalizedResponse = normalize(assignmentResponseData, assignment);
    commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
    return assignmentResponseData.id;
  },
  async [DELETE_ASSIGNMENT_BY_ID]({ commit, state }: any, { assignmentId }) {
    try {
      let replies = await query(
        `
          query getRepliesByAssignmentId($assignmentId: Int!) {
              allReplies(condition: {assignmentId: $assignmentId}){
                nodes {
                    id
                }
            }
          }
          `,
        { assignmentId },
      );
      await Promise.all(
        replies.data.allReplies.nodes.map(reply => {
          return mutation(
            `
              mutation deleteReplyById($replyId: Int!) {
                  deleteReplyById(input: {id: $replyId }){
                    reply { id }
                  }
              }
              `,
            { replyId: reply.id },
          );
        }),
      );
      let deletedAssigmentResponse = await mutation(
        `
              mutation deleteAssigment($assignmentId: Int!) {
                  deleteAssignmentById(input: { id: $assignmentId }) {
                      assignment {
                        id
                      }
                  }
              }
          `,
        { assignmentId },
      );
      if (deletedAssigmentResponse.data.deleteAssignmentById.assignment.id) {
        commit('DELETE_ENTITY', {
          entity: 'assignments',
          id: assignmentId,
        });
        return true;
      } else {
        console.error('Response not expected');
        return false;
      }
    } catch (error) {
      throw new Error(error);
    }
  },
};
